import React from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";
import { I18nProvider, SUPPORTED, DEFAULT_LANG } from "./i18n/I18nContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import LegalPage from "./pages/LegalPage";
import ThankYou from "./pages/ThankYou";

function LangGuard() {
  const location = useLocation();
  const first = location.pathname.split("/").filter(Boolean)[0];
  if (!SUPPORTED.includes(first)) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  }
  return <Outlet />;
}

function LangLayout() {
  return (
    <I18nProvider>
      <div className="flex flex-col min-h-screen bg-white">
        <Header />
        <div className="flex-1">
          <Outlet />
        </div>
        <Footer />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        <Route path="/thank_you" element={<ThankYou />} />
        <Route path="/:lang" element={<LangLayout />}>
          <Route index element={<Home />} />
          <Route
            path="privacy"
            element={<LegalPage ns="privacy" testid="privacy-page" />}
          />
          <Route
            path="cookies"
            element={<LegalPage ns="cookies_page" testid="cookies-page" />}
          />
          <Route
            path="terms"
            element={<LegalPage ns="terms" testid="terms-page" />}
          />
          <Route
            path="*"
            element={<Navigate to={`/${DEFAULT_LANG}`} replace />}
          />
        </Route>
        <Route element={<LangGuard />}>
          <Route
            path="*"
            element={<Navigate to={`/${DEFAULT_LANG}`} replace />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
